import * as THREE from 'three';
import { STLLoader, PLYLoader } from 'three-stdlib';
import { parseVtkPolyData } from './vtkPolyData';
import {
  parseObj, parseVtkAscii, isVtkAscii,
} from './modelFormats';

const fromIndexed = ({ positions, indices }) => {
  const g = new THREE.BufferGeometry();
  g.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  g.setIndex(new THREE.BufferAttribute(indices, 1));
  return g;
};

/**
 * ArrayBuffer файла -> BufferGeometry. Формат: stl | obj | ply | vtk.
 * remap(positions) — необязательное преобразование осей до расчёта нормалей (на месте).
 */
export const buildGeometry = (buffer, format, remap) => {
  let g;
  if (format === 'vtk') {
    g = fromIndexed(isVtkAscii(buffer)
      ? parseVtkAscii(new TextDecoder('ascii').decode(buffer))
      : parseVtkPolyData(buffer));
  } else if (format === 'obj') {
    g = fromIndexed(parseObj(new TextDecoder('utf-8').decode(buffer)));
  } else if (format === 'ply') {
    g = new PLYLoader().parse(buffer);
  } else {
    g = new STLLoader().parse(buffer);
  }
  if (!g.getAttribute('position') || g.getAttribute('position').count === 0) throw new Error('В модели нет вершин');
  g.deleteAttribute('color');
  if (remap) remap(g.getAttribute('position').array);
  g.computeVertexNormals();
  g.computeBoundingBox();
  return g;
};
